import { toast } from "react-toastify";
import i18n from "@/i18n";

const getErrorMessage = (error: any): string => {
  const data = error?.response?.data;

    // Try common message paths
  let message =
    data?.message ??
    data?.error ??
    data?.msg ??
    error?.message ??
    i18n.t("SOMETHING_WENT_WRONG");

    const errors = data?.errors;
    if (errors && Object.values(errors).length > 0) {
      const firstErrorValues = Object.values(errors)[0];
      if(firstErrorValues &&  Array.isArray(firstErrorValues) && firstErrorValues?.length > 0) {
        message =  firstErrorValues[0];
      }
    }
  

  return message;
};

export const handleQueryClientError = (error: any) => {
  const statusCode = error?.response?.status || error?.status || null;

  // Don't show toast for 401 — handled by auth interceptor
  if (statusCode === 401) return;

  const message = getErrorMessage(error);
  toast.error(message);
};
